module.exports = __webpack_public_path__ + "static/media/union-2.094f5a3d.jpg";